module.exports = __webpack_public_path__ + "static/stats-09e343328277fa7c465cc0b0719c7bac.png";